// Single source of truth for the playable scenario list — used by the Host,
// Solo, and Tournament scenario pickers so the id/number/name/group mapping
// only needs to be maintained in one place.

export interface ScenarioListEntry {
  id: string;
  number: number;
  name: string;
  group: string;
}

export const SCENARIO_LIST: ScenarioListEntry[] = [
  { id: 'pegasus-bridge',                     number: 1,  name: 'Pegasus Bridge',                        group: 'Original' },
  { id: 'sainte-mere-eglise',                 number: 2,  name: 'Sainte-Mère-Église',                    group: 'Original' },
  { id: 'sword-beach',                        number: 3,  name: 'Sword Beach',                           group: 'Original' },
  { id: 'pointe-du-hoc',                      number: 4,  name: 'Pointe du Hoc',                         group: 'Original' },
  { id: 'omaha-beach',                        number: 5,  name: 'Omaha Beach',                           group: 'Original' },
  { id: 'mont-mouchet',                       number: 6,  name: 'Mont Mouchet',                          group: 'Original' },
  { id: 'vassieux-vercors',                   number: 7,  name: 'Vassieux, Vercors',                     group: 'Original' },
  { id: 'operation-cobra',                    number: 8,  name: 'Operation Cobra',                       group: 'Original' },
  { id: 'operation-luttich',                  number: 9,  name: 'Operation Lüttich',                     group: 'Original' },
  { id: 'toulon-campaign-for-southern-france', number: 10, name: 'Toulon – Campaign for Southern France', group: 'Original' },
  { id: 'liberation-of-paris',                number: 11, name: 'Liberation of Paris',                   group: 'Original' },
  { id: 'mont-limar',                         number: 12, name: 'Montélimar',                            group: 'Original' },
  { id: 'arnheim-bridge',                     number: 13, name: 'Arnhem Bridge',                         group: 'Original' },
  { id: 'arracourt',                          number: 14, name: 'Arracourt',                             group: 'Original' },
  { id: 'st-vith-ardennes',                   number: 15, name: 'St-Vith, Ardennes',                     group: 'Original' },
  { id: 'saverne-gap-vosges',                 number: 16, name: 'Saverne Gap, Vosges',                   group: 'Original' },
  { id: 'suomussalmi',                        number: 38, name: 'Suomussalmi',                           group: 'Eastern Front' },
];

/** Builds `<optgroup>`/`<option>` markup for a `<select>` scenario picker. */
export function scenarioSelectOptionsHTML(): string {
  const groups = new Map<string, ScenarioListEntry[]>();
  for (const s of SCENARIO_LIST) {
    if (!groups.has(s.group)) groups.set(s.group, []);
    groups.get(s.group)!.push(s);
  }
  return [...groups.entries()].map(([group, entries]) => `
    <optgroup label="— ${group} —">
      ${entries.map(s => `<option value="${s.id}">${s.number}. ${s.name}</option>`).join('\n')}
    </optgroup>`).join('\n');
}

/** Builds a checkbox list (grouped) for a multi-select scenario picker, e.g. Tournament creation. */
export function scenarioCheckboxListHTML(idPrefix: string): string {
  const groups = new Map<string, ScenarioListEntry[]>();
  for (const s of SCENARIO_LIST) {
    if (!groups.has(s.group)) groups.set(s.group, []);
    groups.get(s.group)!.push(s);
  }
  return [...groups.entries()].map(([group, entries]) => `
    <div style="color:#88aa88; font-size:11px; margin:8px 0 4px;">— ${group} —</div>
    ${entries.map(s => `
      <label style="display:flex; align-items:center; gap:6px; padding:3px 0; cursor:pointer;">
        <input type="checkbox" class="scenario-checkbox" id="${idPrefix}-${s.id}" value="${s.id}">
        <span>${s.number}. ${s.name}</span>
      </label>`).join('\n')}`).join('\n');
}
